<div class="container my-4">
    <h4 id="upper">Catégories de Produits </h4>


    <div class="card shadow-sm">

        <!-- Barre de recherche dans la même card -->
        <div class="card-body border-bottom">

            <div class="d-flex justify-content-between align-items-center">

                <!-- Barre de recherche -->
                <div class="input-group w-50">
                    <input type="text" class="form-control" placeholder="Rechercher une catégorie..." id="searchInput">
                </div>

                <!-- Bouton Ajouter -->
                <a (click)="openModal()" title="Cliquez ici pour ajouter un certificat de décès"
                    style="background-color:#578D63;" href="javascript:void(0);" class="btn btn-success" id="gras">
                    <i class="mdi mdi-plus me-2"></i> Ajouter
                </a>

            </div>

        </div>


        <!-- Tableau dans la même card -->
        <div class="card-body p-0">
            <div class="table-responsive">

                <table class="table table-hover align-middle mb-0">

                    <thead class="table-light">
                        <tr>
                            <th>Nom</th>
                            <th>Description</th>
                            <th>Date de création</th>
                            <th class="text-center">Actions</th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr *ngFor="let item of paginatedItems">
                            <td><strong>{{item.nom}}</strong></td>
                            <td>{{item.description}}</td>
                            <td>{{item.type}}</td>

                            <td class="text-center fw-medium">
                                <!-- Modifier -->
                                <a (click)="editOpenModal(item)" class="me-3 text-primary" style="cursor:pointer;"
                                    title="Modifier">
                                    <i class="mdi mdi-pencil font-size-18"></i>
                                </a>

                                <!-- Supprimer -->
                                <a (click)="confirmSuppression(item)" class="text-danger" style="cursor:pointer;"
                                    title="Supprimer">
                                    <i class="mdi mdi-trash-can font-size-18"></i>
                                </a>

                            </td>
                        </tr>

                    </tbody>

                </table>

                <div class="d-flex justify-content-center mt-4" *ngIf="isLoading === true">
                    <div class="container">
                        <div class="row">
                            <div class="text-center">
                                <h5 id="graycolor">Chargement en cours...</h5>
                                <div class="loader4"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Message d'erreur -->
                <div *ngIf="hasError && !isLoading" class="text-center my-5">
                    <i class="bi bi-exclamation-circle text-danger" style="font-size: 2rem;"></i>
                    <p class="text-danger">{{ errorMessage }}</p>
                    <button class="btn btn-primary" (click)="getCategorieProduit()"><i class="pi pi-refresh"
                            style="font-size: 2rem"></i>
                    </button>
                </div>
                <div *ngIf="paginatedItems.length === 0 && isLoading === false"
                    class="d-flex justify-content-center mt-4">
                    <div class="container">
                        <div class="row">
                            <div class="text-center">
                                <h5 id="graycolor">Aucune donnée trouvée</h5>
                            </div>
                        </div>
                    </div>

                </div>
                <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
                    [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
                </p-paginator>
            </div>
        </div>

    </div>

</div>
<p-toast position="top-center" />
<p-confirmDialog />
<ngx-ui-loader></ngx-ui-loader>